<template>
	<div class="form popup-form">
		<div v-if="getClients.length > 0">
			<div class="w-100">
				<label class="select-label d-table w-100 text-center mt-30px mb-30px">Ügyfelek</label>
				<select name="client" class="mw-500px d-table" v-model="selectedClient" @change="handleSelect">
					<option v-for="(client, index) in getClients" :key="index" :value="client.id">
						{{ client.name }}
					</option>
				</select>
			</div>
			<label class="select-label d-table w-100 text-center mt-30px mb-30px" v-if="getRealEstates.length > 0">
				{{ getRealEstates.length > 1 ? 'Elérhető ingatlan adatok' : 'Elérhető ingatlan adatok:' }}
			</label>
			<label class="select-label d-table w-100 text-center mt-30px mb-30px" v-else>
				Az ügyfélnek még nincs ingatlan adat felvéve!
			</label>
			<span class="d-flex fs-bold justify-center mt-12px text-center" v-if="getRealEstates.length === 1">
				{{ makeAddress(getRealEstates[0]) }}
			</span>
			<div class="w-100" v-if="getRealEstates.length > 1">
				<select name="real_estate" class="mw-500px d-table" v-model="selected">
					<option v-for="(real_estate, index) in getRealEstates" :key="index" :value="real_estate.id">
						{{ makeAddress(real_estate) }}
					</option>
				</select>
			</div>
			<div class="d-flex">
				<button
					type="button"
					class="btn btn-blue-inverse m-auto mt-30px"
					@click="selectNewRealEstate"
					style="margin-right: 15px"
					:disabled="selectedClient === null"
				>
					Új ingatlan
				</button>
				<button
					type="button"
					class="btn btn-blue m-auto mt-30px"
					@click="selectRealEstate"
					style="margin-left: 15px"
					:disabled="selectedClient === null || selected === null"
				>
					Tovább
				</button>
			</div>
		</div>

		<div v-else>Még nincs ügyfeled! Az admin felületen tudsz felvenni új ügyfelet!</div>
	</div>
</template>

<script>
import Select from '@/components/elements/Select';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	components: {
		Select,
	},
	data() {
		return {
			selected: null,
			selectedClient: null,
		};
	},
	computed: {
		...mapGetters('auth', ['getClients']),
		...mapGetters(['getRealEstates', 'getSelectedUser']),
	},
	methods: {
		...mapMutations(['showPopup', 'setSelectedUser']),
		...mapActions(['setSelectedRealEstateData', 'clearSelectedRealEstateData', 'fetchClientRealEstates']),
		selectRealEstate() {
			this.setSelectedUser(this.selectedClient);
			this.setSelectedRealEstateData(this.selected);
			this.$router.push({ name: 'property-details' });
			this.showPopup(null);
		},
		selectNewRealEstate() {
			this.setSelectedUser(this.selectedClient);
			this.clearSelectedRealEstateData();
			this.$router.push({ name: 'property-details' });
			this.showPopup(null);
		},
		async handleSelect() {
			await this.fetchClientRealEstates(this.selectedClient);
			this.selected = this.getRealEstates.length > 0 ? this.getRealEstates[0].id : null;
		},
		makeAddress(realEstate) {
			let address = `${realEstate.postal_code} ${realEstate.city}, ${realEstate.address} `;

			if (realEstate.house_number !== null) {
				address += `${realEstate.house_number}.`;
			} else {
				address += `| ${realEstate.parcel_number}`;
			}

			return address;
		},
	},
};
</script>
